
import { connect } from 'react-redux';
import { ComplexValue } from 'app/types-shared';
import { actionCreators } from './actions';
import { createUploader } from 'app/infrastructure/remote-data';
import { endpoint } from 'app/area/case/features/file-upload/constants';

export const withFileUpload = (component: any, uiEngineProps: any) => {
  const dispatchToProps = (dispatch: any): Partial<FileUploadContainerProps> => {
    const hostProps = uiEngineProps.hostProps();
    const entityId = hostProps.entityId;

    return {
      createUploader: async () => await createUploader(endpoint.uploadFor(entityId)),
      addItem: (blobId: number, title: string) =>
        dispatch(actionCreators.addAttachment(uiEngineProps, blobId, title)),
      deleteItem: (id: number) =>
        dispatch(actionCreators.deleteAttachment(uiEngineProps, id)),
      updateItemTitle: (id: number, title: string) =>
        dispatch(actionCreators.updateAttachmentTitle(uiEngineProps, id, title)),
      setItemAsMain: (id: number) =>
        dispatch(actionCreators.setMainAttachmentImage(uiEngineProps, id))
    };
  };

  return connect<any, any, any>(null, dispatchToProps)(component);
};

export interface UploadedFile {
  id?: number; // No. column of attachment row
  blobId?: number; // Blob id of attachment row if the file has been uploaded
  name: string;
  title: string;
  type: string;
  size: number;
  thumbnailSize?: number;
  attachedBy?: ComplexValue<number>;
  attachedAt?: Date;
  mainImage?: boolean;
}

export interface FileUploadContainerProps {
  createUploader?: () => Promise<XMLHttpRequest>;
  addItem?: (blobId: number, name: string) => void;
  deleteItem?: (id: number) => void;
  updateItemTitle?: (id: number, name: string) => void;
  setItemAsMain?: (id: number) => void;
}
